import request from "@/http/axios/axios";

// 验证码

// 发送邮箱验证码
export const fetchSendEmailCode = async function (data: any): Promise<any> {
  return await request.post(`/api/user/sendEmailCode`, data, { skipAuth: true });
};

// 退出登录
export const fetchLogout = async function (data?: any): Promise<any> {
  return await request.post(`/api/user/logout`, data);
};

// 刷新Token
export const fetchRefreshToken = async function (data?: any): Promise<any> {
  return await request.post(`/api/user/refreshToken`, data, { skipAuth: true });
};

// 用户端注册
export const fetchRegisterUser = async function (data: any): Promise<any> {
  return await request.post(`/api/user/registerUser`, data, { skipAuth: true });
};

// 设置兑换码
export const fetchSetRedemptionCode = async function (data: any): Promise<any> {
  return await request.post(`/api/user/setRedemptionCode`, data);
};

// 修改用户信息
export const fetchUpdateUser = async function (data: any): Promise<any> {
  return await request.post(`/api/user/updateUser`, data);
};

// 使用兑换码
export const fetchUseRedemptionCode = async function (data: any): Promise<any> {
  return await request.post(`/api/user/useRedemptionCode`, data);
};

// 获取用户信息
export const fetchUserInfo = async function (data?: any): Promise<any> {
  return await request.get(`/api/user/userInfo`, data);
};

// 用户端登录
export const fetchUserLogin = async function (data?: any): Promise<any> {
  return await request.post(`/api/user/userLogin`, data, { skipAuth: true });
};

// 验证兑换码
export const fetchVerifyRedemptionCode = async function (data?: any): Promise<any> {
  return await request.post(`/api/user/verifyRedemptionCode`, data, { skipAuth: true });
};

export const fetchPullUp = async function (): Promise<any> {
  return await request.get(`/sam2-server/pullUp`);
};

// 获取 RSA 公钥
export const fetchRSAPublicKey = async function (): Promise<any> {
  return await request.get(
    `/api/user/rsa-public-key`,
    {},
    {
      skipAuth: true
    }
  );
};
